import React from "react";
import { Trans, useTranslation } from "react-i18next";
import cn from "clsx";

import { useRouteSlug } from "@/hooks";
import { useAppSelector } from "@/redux/store";
import { selectStaticAssets } from "@/util/selectors";

import "./style.scss";

const TermsAndPrivacy = ({ className }: { className?: string }) => {
  const routeSlug = useRouteSlug();
  const staticAssets = useAppSelector(selectStaticAssets);
  const { t } = useTranslation("auth");

  return (
    <p className={cn("termsAndCondition", className)}>
      <Trans
        i18nKey="youAgreeTo"
        ns="auth"
        t={t}
        components={{
          terms: (
            <a
              href={`/${routeSlug}${staticAssets?.termsAndConditionsSlug}`}
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            />
          ),
          privacy: (
            <a
              href={`/${routeSlug}${staticAssets?.privacyPolicySlug}`}
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            />
          )
        }}
      />
    </p>
  );
};

export default TermsAndPrivacy;
